import request, { METHODS } from "src/utils/api-base";

const authAdminApis = {
  login: (payload: { email: string; password: string }) => {
    return request({
      route: "/admin/auth/login",
      method: METHODS.POST,
      payload,
    });
  },
  getUserDetails: () =>
    request({
      route: "/admin/auth/get-user-info",
      method: METHODS.GET,
      auth: true,
      isAdminAuth: true,
    }),
  updateProfile: (payload: {
    firstName: string;
    lastName?: string;
    email: string;
    password?: string;
  }) =>
    request({
      route: "/admin/auth/update-profile",
      method: METHODS.PUT,
      payload,
      auth: true,
      isAdminAuth: true,
    }),
  changePassword: (payload: { oldPassword: string; newPassword: string }) =>
    request({
      route: "/admin/auth/change-password",
      method: METHODS.PUT,
      payload,
      auth: true,
      isAdminAuth: true,
    }),
};

export default authAdminApis;
